import React from "react";
import styled from "styled-components";
import { breakpoints } from "@trailhead/asurion-ui";
import SmartHouse from "../assets/SmartHouse.svg";
import { ExpertChat } from ".";
import { AEClient, TwilioClient } from "@trailhead/chat";

const Container = styled.div`
  width: 100vw;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;

  ${breakpoints.md} {
    background-color: #f0f0f5;
    margin: 0 -100vw;
  }

  ${breakpoints.mdOnly} {
    padding-bottom: 3rem;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1200px;

  ${breakpoints.lg} {
    justify-content: space-between;
  }
`;

const ImageContainer = styled.div`
  width: 50%;
  display: none;
  align-items: center;
  justify-content: center;
  flex-shrink: 2;

  ${breakpoints.lg} {
    display: flex;
  }
`;

const Image = styled.img`
  width: 500px;
  height: 500px;
`;

export const ChatPromptsCTA: React.FC<{
  chatClient?: typeof AEClient | typeof TwilioClient;
}> = ({ chatClient = TwilioClient }) => (
  <Container>
    <ContentContainer>
      <ImageContainer>
        <Image src={SmartHouse} />
      </ImageContainer>
      <ExpertChat chatClient={chatClient} />
    </ContentContainer>
  </Container>
);
